<div class="contextmenu cursor-pointer" [ngStyle]="{'left.px': x, 'top.px': y}">
    <div (click)="addFolder()" id = "createFolderRightClick">
        <b>Create Folder</b>
    </div>
     <!-- <hr>
    <b (click)="renameFolder()">Rename Folder</b>
    <ng-container  *ngIf="token==='true'">
    <hr>
    <div routerLink="/val-assets/upload-assets" style="outline:none;" id="uploadAssetRightClick">
        <b >Upload Asset</b>
    </div>
</ng-container> -->
</div> 